export default "__VITE_ASSET__NtxvFvnh__"